import firebase from "firebase/compat/app";
import "firebase/compat/storage";

// Initializes Firebase storage instance with project configuration and exports it for use.
const firebaseConfig = {
  apiKey: "AIzaSyC3rdc6BpUCiDA22ZSaasrVp0otbuLl9bY",
  authDomain: "event-app-e8100.firebaseapp.com",
  projectId: "event-app-e8100",
  storageBucket: "event-app-e8100.appspot.com",
  messagingSenderId: "970692557605",
  appId: "1:970692557605:web:9e221d9e259aad5d76f8cc",
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export { storage };
